<template>
  <div class="form-group d-flex flex-wrap col-12 mb-16">
    <div class="col-12">
      <label class="form-label">{{ trans.cardInfoLabel }} *</label>
      <div id="card-number" class="form-control"></div>
    </div>

    <div class="col-12 col-lg-6">
      <div id="card-expiry" class="form-control"></div>
    </div>

    <div class="col-12 col-lg-6">
      <div id="card-cvc" class="form-control"></div>
    </div>

    <div
        id="stripe-element-form--errors"
        class="mt-16 mb-16 error"
        role="alert"
        ref="errors"
    ></div>
  </div>
</template>

<script>

import {ErrorMessage, Field} from "vee-validate";

export default {
  name: 'StripePaymentCardMethod',
  props: {
    trans: {
      required: true,
    },
    stripe: {
      required: true,
      type: Object,
    },
  },
  components: {
    Field,
    ErrorMessage,
  },
  data() {
    return {
      cardNumber: '',
      cardExpiry: '',
      cardCvc: '',
    }
  },
  async mounted() {
    let elements = this.stripe.elements();

    let elementClasses = {
      focus: 'focus',
      empty: 'empty',
      invalid: 'is-invalid',
    };

    let elementStyles = {
      base: {
        color: '#FFFFFF',
        fontWeight: 500,
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: 'rgba(255, 255, 255, 0.3)',
        },
      },

      invalid: {
        color: '#F32859',
      },
    };

    /* Card Payment Method */

    this.cardNumber = elements.create('cardNumber', {
      style: elementStyles,
      classes: elementClasses,
    });

    this.cardNumber.mount('#card-number');

    this.cardExpiry = elements.create('cardExpiry', {
      style: elementStyles,
      classes: elementClasses,
    });

    this.cardExpiry.mount('#card-expiry');

    this.cardCvc = elements.create('cardCvc', {
      style: elementStyles,
      classes: elementClasses,
    });

    this.cardCvc.mount('#card-cvc');

    this.registerElements([this.cardNumber, this.cardExpiry, this.cardCvc]);
  },
  methods: {
    registerElements: function (elements) {
      this.$emit('registerElements', elements);
    },
    async createCardToken() {
      return await this.stripe.createToken(this.cardNumber);
    },
  },
}
</script>
